export default [
  {
    path: 'monitor/:id?',
    name: 'cottonSmolderingMonitor',
    component: () => import('@/views/cotton/monitor'),
    meta: {
      activeMenu: '/cotton',
      hidden: true,
      noPadding: true
    }
  },
  {
    path: 'monitor2/:id?',
    name: 'cottonSmolderingMonitor2',
    component: () => import('@/views/cotton/monitor/List/index.vue'),
    meta: {
      activeMenu: '/cotton',
      hidden: true,
      noPadding: true
    }
  }
];
